"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeCheckoutSessionId = exports.getCheckoutSessionId = void 0;
const tslib_1 = require("tslib");
const data_capsule_1 = require("@wix/data-capsule");
const generateGUID_1 = require("./guid/generateGUID");
/**
 * checkoutSessionId should expire in 24hr or when payment is complete
 */
const getCapsuleKey = (uniqueCheckoutKey) => `${uniqueCheckoutKey}:__CheckoutSessionId__`;
const SESSION_ID_EXPIRATION = 86400; // 24hr in seconds
const capsule = new data_capsule_1.DataCapsule({
    strategy: new data_capsule_1.LocalStorageStrategy(),
    namespace: 'payments-checkout',
});
/**
 * Function will return checkoutSessionId for bi events.
 * Will create new one with 1day expiration
 * If already expired - generate new one.
 * If capsule or general LocalStorage not working - it will generate new one each call
 * @returns Promise<string>
 * @callback onError will be called if local storage is not available
 */
const getCheckoutSessionId = (uniqueCheckoutKey, onError) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    let checkoutSessionId;
    try {
        checkoutSessionId = yield capsule.getItem(getCapsuleKey(uniqueCheckoutKey));
    }
    catch (e) { }
    if (!checkoutSessionId) {
        const newSessionId = (0, generateGUID_1.generateGUID)();
        try {
            yield capsule.setItem(getCapsuleKey(uniqueCheckoutKey), newSessionId, {
                expiration: SESSION_ID_EXPIRATION,
            });
        }
        catch (error) {
            onError(error);
        }
        checkoutSessionId = newSessionId;
    }
    return checkoutSessionId;
});
exports.getCheckoutSessionId = getCheckoutSessionId;
/**
 * Will remove sessionId from localStorage (in paymentComplete case)
 * @returns Promise<void>
 */
const removeCheckoutSessionId = (uniqueCheckoutKey, onError) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    try {
        yield capsule.removeItem(getCapsuleKey(uniqueCheckoutKey));
    }
    catch (error) {
        onError === null || onError === void 0 ? void 0 : onError(error);
    }
});
exports.removeCheckoutSessionId = removeCheckoutSessionId;
//# sourceMappingURL=checkoutSessionId.js.map